import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { TextField, Button, Box, Typography, Paper, InputAdornment } from '@mui/material';
import backgroundImage from '../assets/login/BACKGROUND.png';
import logo from '../assets/logo.png'
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate } from 'react-router-dom';
import { userLogin } from '../services/User';

const LoginPage = () => {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email('Please enter a valid email address.')
        .required('The email field is required.'),
      password: Yup.string()
        .min(6, 'Password must be at least 6 characters long.')
        .required('The password field is required.'),
    }),
    onSubmit: async (values) => {
      try {
        const result = await userLogin(values);
        
        if (result.error) {
          setError(result.error);
        } else {
          localStorage.setItem('token', result.token);
          localStorage.setItem('admin', JSON.stringify(result.admin));
          navigate("/admin");
        }
      } catch (error) {
        setError('Failed to login. Please try again.');
      }
    },
  });

  return (
    <Box
      sx={{
        height: '100vh',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          padding: 6,
          borderRadius: { md: '30px' },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '600px',
          height: { sm: 'auto', xs: '100%' },
          boxShadow: ' 0px 0px 74px 0px #01A0E21A'
        }}
      >
        <Box  >
          <img src={logo} alt="logo" style={{ height: "50px" }} />
        </Box>
        <form onSubmit={formik.handleSubmit} style={{ width: '100%' }}>
          {error && (
            <Typography color="error" variant="body2" sx={{ mb: 2, textAlign: 'center' }}>
              {error}
            </Typography>
          )}
          <Typography variant="body2" ml={2} mt={2}>
            Email
          </Typography>
          <TextField
            fullWidth
            id="email"
            name="email"
            variant="outlined"
            placeholder='Enter email'
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailOutlinedIcon />
                </InputAdornment>
              ),
            }}
            sx={{
              mt: 1,
              '& .MuiInputBase-input:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #EDF4F7 inset',
              },
              '& .MuiOutlinedInput-root': {
                border: 'none',
                backgroundColor: '#EDF4F7',
                borderRadius: '50px',
                '& fieldset': {
                  border: 'none',
                },
                '&:hover fieldset': {
                  border: 'none',
                },
                '&.Mui-focused fieldset': {
                  border: 'none',
                },
              },
            }}
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />
          <Typography variant="body2" ml={2} mt={2}>
            Password
          </Typography>
          <TextField
            fullWidth
            placeholder='Enter password'
            id="password"
            name="password"
            type="password"
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockOutlinedIcon />
                </InputAdornment>
              ),
            }}
            sx={{
              mt: 1,
              '& .MuiInputBase-input:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #EDF4F7 inset',
              },
              '& .MuiOutlinedInput-root': {
                border: 'none',
                backgroundColor: '#EDF4F7',
                borderRadius: '50px',
                '& fieldset': {
                  border: 'none',
                },
                '&:hover fieldset': {
                  border: 'none',
                },
                '&.Mui-focused fieldset': {
                  border: 'none',
                },
              },
            }}
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
          />
          <Button variant="contained" fullWidth type="submit" sx={{ mt: 2, backgroundColor: '#01A0E2', color: '#fff', borderRadius: 0 }} size="large">
            Login
          </Button>
        </form>
      </Paper>
    </Box>
  );
};

export default LoginPage;